import React from "react";


import aboutUsAll from '../../../resource/image/about-us/aboutusimage.jpeg'



function AboutUsSection({ siteConfig }) {


  return (

      <>
        <div className="overflow-hidden bg-white py-24 sm:py-32">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div
                className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
              <div className="lg:pr-8 lg:pt-4">


                <div className="lg:max-w-lg">
                  <h4 className="text-main-100 uppercase tracking-widest  sec-head-font">
                    {siteConfig?.about?.label ?? ""}
                  </h4>
                  <h2 className="text-4xl sec-breif-font text-bf-100 mt-2">
                    {siteConfig.about.title}

                  </h2>
                  <p className="text-dc-100 sec-desc-font mt-4 leading-relaxed">
                    {siteConfig?.about?.description ?? ""}

                  </p>
                </div>


              </div>

              <div className="relative aspect-square w-full rounded-2xl  [&amp;:has(>_.active-card)]:bg-transparent">
                <div className="absolute inset-0 h-full w-full rounded-2xl transition-opacity active-card opacity-100">
                  <img
                      alt="Modern Bathroom"
                      src={aboutUsAll}
                      width={2432}
                      height={1442}
                      className=" h-full w-full object-cover object-left"
                  />
                  <div className="absolute -inset-y-px right-0 z-10 w-1/4   bg-gradient-to-l from-white"></div>

                </div>
              </div>


            </div>
          </div>
        </div>


        {/*<section className=" mx-auto px-6 py-16 flex flex-col lg:flex-row items-center" id='about-us'>*/}

        {/*  /!* Left Content *!/*/}
        {/*  <div className="lg:w-1/2 text-left">*/}
        {/*    <h4 className="text-blue-500 uppercase tracking-widest font-normal" style={{color: '#3C86A7'}}>*/}
        {/*      {siteConfig?.about?.label ?? ""}*/}
        {/*    </h4>*/}
        {/*    <h2 className="text-4xl font-bold text-gray-900 mt-2" style={{color: '#383A42'}}>*/}
        {/*      {siteConfig.about.title}*/}

        {/*    </h2>*/}
        {/*    <p className="text-gray-600 mt-4 leading-relaxed" style={{color: '#818793'}}>*/}
        {/*      {siteConfig?.about?.description ?? ""}*/}

        {/*    </p>*/}
        {/*  </div>*/}


        {/*  /!* Right Content (Images) *!/*/}

        {/*  <div className="lg:w-1/2 relative">*/}
        {/*    <div className="relative left-6 rounded-2xl overflow-hidden">*/}
        {/*      <img*/}
        {/*          src={aboutUsAll} // Replace with actual image URL*/}
        {/*          alt="Modern Bathroom"*/}
        {/*          className="w-full h-full object-cover"*/}
        {/*      />*/}
        {/*    </div>*/}

        {/*    /!* Decorative Background Elements *!/*/}
        {/*    <div className="absolute -z-10 top-10 left-10 w-40 h-40 bg-blue-100 rounded-2xl"></div>*/}
        {/*    <div className="absolute -z-10 bottom-10 right-10 w-32 h-32 bg-gray-100 rounded-2xl"></div>*/}
        {/*  </div>*/}

        {/*</section>*/}


      </>
  );
}

export default AboutUsSection;
